import { defineMessages } from 'react-intl';

export default defineMessages({
    submitTitleCA:{
        "id":"payrollreporting.requestchange.reviewCAL.Certify Payroll",
        "defaultMessage":"Certify Entries"
    },
    PEsubmitMessageCA:{
        "id":"PEpayrollreporting.reviewCAL1.I certify that the payroll figures appearing in this report are a true and correct statement of all the earnings by all employees of the insured for the period stated. I further certify that I have been authorized by the insured to submit this information on its behalf.",
        "defaultMessage":"I certify that the entries figures appearing in this report are a true and correct statement of all the earnings by all employees of the insured for the period stated. I further certify that I have been authorized by the insured to submit this information on its behalf."
    },
    submitMessageCA:{
        "id":"payrollreporting.reviewCALine..AI certify that payroll figures appearing in this report are true and a complete statement of all the earnings by all of our employees for the period stated",
        "defaultMessage":"I certify that entries figures appearing in this report are true and a complete statement of all the earnings by all of our employees for the period stated."
    },

});